export const SPECIAL_AND_CODE = "&amp;"
export const SPECIAL_AND_SYMBOL = "&"
